import { KeepAliveParams as KmmKeepAliveParams } from '@norlys-a-s/norlys-play-kmm';
import { retryAsync } from '@smart-tv/utils/retry';

import { kmm } from './kmm';

export interface KeepStreamAliveParams {
  sid?: number;
  eventId?: number;
  mediaId?: number;
  progress?: number;
}

const toKmmKeepAliveParams = (params: KeepStreamAliveParams): KmmKeepAliveParams => {
  const { sid, eventId, mediaId, progress } = params;
  const positionSeconds = progress ?? 0;

  if (mediaId) {
    return new KmmKeepAliveParams.OnDemandStreamParams(mediaId, positionSeconds);
  }

  if (sid && eventId) {
    return new KmmKeepAliveParams.ChannelEventStreamParams(sid, eventId, positionSeconds);
  }

  return new KmmKeepAliveParams.ChannelLiveStreamParams(sid ?? 0);
};

export const keepStreamAlive = (params: KeepStreamAliveParams): Promise<boolean> => {
  const keepAliveParams = toKmmKeepAliveParams(params);

  return retryAsync(() => kmm((repo) => repo.api.keepAlive(keepAliveParams), false), {
    maxRetries: 3,
    baseDelayMs: 200
  });
};

export default keepStreamAlive;
